import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import Cookies from 'js-cookie'
import API_BASE_URL from '../../../config/api'
import Topbar from '../mini-comp/Topbar'
import Sidebar from '../mini-comp/Sidebar'
import Swal from 'sweetalert2'
import { RiLockPasswordLine, RiSave3Line, RiEyeLine, RiEyeOffLine } from 'react-icons/ri'

const EmployeeChangePassword = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        old_password: '',
        new_password: '',
        confirm_password: ''
    });
    const [loading, setLoading] = useState(false);
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation
        if (formData.new_password.length < 6) {
            Swal.fire('Error', 'New password must be at least 6 characters long.', 'error');
            return;
        }

        if (formData.new_password !== formData.confirm_password) {
            Swal.fire('Error', 'New password and confirm password do not match.', 'error');
            return;
        }

        setLoading(true);

        try {
            const token = Cookies.get('token');
            const response = await axios.post(`${API_BASE_URL}/api/v1/users/change-password/`, {
                old_password: formData.old_password,
                new_password: formData.new_password
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Password changed successfully.',
                showConfirmButton: true
            })

        } catch (error) {
            console.error('Change password error:', error);
            const errorMessage = error.response?.data?.detail || error.response?.data?.error || 'Failed to change password. Please check your old password.';
            Swal.fire('Error', errorMessage, 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Topbar />
            <Sidebar />

            <div className="app-content-area">
                <div className="app-content-wrap">
                    <div className="container-fluid">

                        <div className="row mt-3 justify-content-center">
                            <div className="col-xl-9 col-lg-10">
                                <div className="card shadow-sm border-0">
                                    <div className="card-header bg-transparent border-bottom p-4">
                                        <h5 className="card-title mb-0 d-flex align-items-center gap-2">
                                            <RiLockPasswordLine className="text-primary" size={20} />
                                            Update Your Password
                                        </h5>
                                    </div>
                                    <div className="card-body p-4">
                                        <form onSubmit={handleSubmit}>
                                            <div className="mb-3">
                                                <label className="form-label" htmlFor="old_password">Current Password <span className="text-danger">*</span></label>
                                                <div className="input-group">
                                                    <input
                                                        type={showOldPassword ? "text" : "password"}
                                                        className="form-control"
                                                        id="old_password"
                                                        name="old_password"
                                                        placeholder="Enter current password"
                                                        value={formData.old_password}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                    <button
                                                        className="btn btn-outline-secondary"
                                                        type="button"
                                                        onClick={() => setShowOldPassword(!showOldPassword)}
                                                    >
                                                        {showOldPassword ? <RiEyeOffLine /> : <RiEyeLine />}
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label" htmlFor="new_password">New Password <span className="text-danger">*</span></label>
                                                <div className="input-group">
                                                    <input
                                                        type={showNewPassword ? "text" : "password"}
                                                        className="form-control"
                                                        id="new_password"
                                                        name="new_password"
                                                        placeholder="Enter new password (min. 6 characters)"
                                                        value={formData.new_password}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                    <button
                                                        className="btn btn-outline-secondary"
                                                        type="button"
                                                        onClick={() => setShowNewPassword(!showNewPassword)}
                                                    >
                                                        {showNewPassword ? <RiEyeOffLine /> : <RiEyeLine />}
                                                    </button>
                                                </div>
                                                <div className="form-text">Must be at least 6 characters long.</div>
                                            </div>

                                            <div className="mb-4">
                                                <label className="form-label" htmlFor="confirm_password">Confirm New Password <span className="text-danger">*</span></label>
                                                <div className="input-group">
                                                    <input
                                                        type={showConfirmPassword ? "text" : "password"}
                                                        className="form-control"
                                                        id="confirm_password"
                                                        name="confirm_password"
                                                        placeholder="Re-enter new password"
                                                        value={formData.confirm_password}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                    <button
                                                        className="btn btn-outline-secondary"
                                                        type="button"
                                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                    >
                                                        {showConfirmPassword ? <RiEyeOffLine /> : <RiEyeLine />}
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="d-flex justify-content-end gap-2">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary px-4 d-flex align-items-center gap-2"
                                                    disabled={loading}
                                                >
                                                    {loading ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                            Updating...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <RiSave3Line /> Update Password
                                                        </>
                                                    )}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default EmployeeChangePassword